interface ValidationError {
  loc: (string | number)[];
  msg: string;
  type: string;
}

const looksLikeValidationError = (value: unknown): value is ValidationError =>
  !!value && typeof value === 'object' && 'msg' in value && typeof (value as ValidationError).msg === 'string';

export const extractBackendErrorMessage = (err: unknown): string | null => {
  if (!err) return null;
  const anyErr = err as Record<string, any>;

  const detail = anyErr.user_msg ?? anyErr.detail ?? anyErr.body?.user_msg ?? anyErr.body?.detail;

  if (typeof detail === 'string' && detail.trim()) return detail;

  if (Array.isArray(detail)) {
    const messages = detail.filter(looksLikeValidationError).map(v => v.msg);
    if (messages.length > 0) return messages.join(', ');
  }

  if (detail && typeof detail === 'object') {
    const nested = (detail as Record<string, any>).user_msg ?? (detail as Record<string, any>).msg;
    if (typeof nested === 'string' && nested.trim()) return nested;
  }

  if (typeof anyErr.message === 'string' && anyErr.message.trim()) return anyErr.message;
  return null;
};

export const parseFetchError = async (response: Response): Promise<Error> => {
  let body: unknown;
  try {
    body = await response.clone().json();
  } catch {
    try {
      body = await response.text();
    } catch {
      body = null;
    }
  }
  const error = new Error(`Request failed (${response.status})`) as Error & { status: number; body: unknown };
  error.status = response.status;
  error.body = body;
  return error;
};
